module.exports = __webpack_public_path__ + "media/images/athletes/3555-66d5768a56cd06e1fc99d7496ec62545.png";